export const monthMap: Record<string, string> = {
  '01': 'Jan', '02': 'Feb', '03': 'Mar', '04': 'Apr',
  '05': 'May', '06': 'Jun', '07': 'Jul', '08': 'Aug',
  '09': 'Sep', '10': 'Oct', '11': 'Nov', '12': 'Dec'
};


export const daysInMonth: { [key: string]: number } = {
  '01': 31, '02': 29, '03': 31, '04': 30,
  '05': 31, '06': 30, '07': 31, '08': 31,
  '09': 30, '10': 31, '11': 30, '12': 31,
};